import React from 'react';

const HowToSellPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white mb-4">Come Vendere</h1>
        <p className="text-white/70 text-xl max-w-2xl">
          Affidati a Equus Prime per vendere il tuo cavallo. Ti accompagniamo in ogni fase del processo.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl">
        <div className="space-y-12">
          <div>
            <h2 className="font-display text-3xl mb-6 text-[#c9a227]">Requisiti</h2>
            <ul className="space-y-4 text-lg">
              <li className="flex gap-4">
                <span className="text-[#c9a227]">✓</span>
                <span>Account verificato su Equus Prime</span>
              </li>
              <li className="flex gap-4">
                <span className="text-[#c9a227]">✓</span>
                <span>Documentazione del cavallo completa</span>
              </li>
              <li className="flex gap-4">
                <span className="text-[#c9a227]">✓</span>
                <span>Certificato veterinario recente (max 7 giorni)</span>
              </li>
              <li className="flex gap-4">
                <span className="text-[#c9a227]">✓</span>
                <span>Foto e video di qualità del cavallo</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-3xl mb-6 text-[#c9a227]">Processo</h2>
            <div className="space-y-6">
              <div className="flex gap-6">
                <div className="w-12 h-12 bg-[#c9a227] text-[#0a1628] rounded-full flex items-center justify-center font-bold flex-shrink-0">1</div>
                <div>
                  <h3 className="font-display text-xl mb-2">Contattaci</h3>
                  <p className="text-[#64748b]">Scrivi a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a> con i dettagli del cavallo che vuoi vendere.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="w-12 h-12 bg-[#c9a227] text-[#0a1628] rounded-full flex items-center justify-center font-bold flex-shrink-0">2</div>
                <div>
                  <h3 className="font-display text-xl mb-2">Valutazione</h3>
                  <p className="text-[#64748b]">Il nostro team valuterà la proposta e ti contatterà per discutere i dettagli.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="w-12 h-12 bg-[#c9a227] text-[#0a1628] rounded-full flex items-center justify-center font-bold flex-shrink-0">3</div>
                <div>
                  <h3 className="font-display text-xl mb-2">Pubblicazione</h3>
                  <p className="text-[#64748b]">Una volta approvato, il cavallo verrà inserito nella prossima asta disponibile.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="w-12 h-12 bg-[#c9a227] text-[#0a1628] rounded-full flex items-center justify-center font-bold flex-shrink-0">4</div>
                <div>
                  <h3 className="font-display text-xl mb-2">Vendita</h3>
                  <p className="text-[#64748b]">Al termine dell'asta, ti contatteremo con i dettagli dell'acquirente per finalizzare la vendita.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#f8f9fa] p-8">
            <h2 className="font-display text-3xl mb-4">Pronto a vendere?</h2>
            <p className="text-[#64748b] mb-6">
              Contattaci oggi stesso per iniziare il processo di vendita.
            </p>
            <a href="mailto:info@equusprime.it" className="btn-primary inline-block">
              Contattaci
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);


const PrivacyPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Politica sulla Privacy</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl prose prose-lg">
        <h2 className="font-display text-2xl">Informazioni Generali</h2>
        <p>Equus Prime è di proprietà di Blinkers Srl, che ne cura anche la gestione. La presente Politica sulla Privacy contiene informazioni su come Equus Prime tratta i dati personali. La nostra ambizione è essere il più trasparenti possibile riguardo al trattamento dei tuoi dati e fare tutto il possibile per proteggerli.</p>

        <h2 className="font-display text-2xl mt-8">Titolare del Trattamento</h2>
        <p>
          <strong>Blinkers Srl</strong><br />
          P.IVA: 11115801216<br />
          Via Isonzo 36<br />
          80034 Marigliano (NA)<br />
          E-mail: <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a><br />
          Sito web: <a href="https://equusprime.it" className="text-[#c9a227]">https://equusprime.it</a>
        </p>

        <h2 className="font-display text-2xl mt-8">Quali dati personali trattiamo e perché?</h2>
        <p>Equus Prime tratta i tuoi dati personali:</p>
        <ul>
          <li>quando fai offerte, vendi o acquisti su Equus Prime</li>
          <li>quando ti iscrivi ai nostri eventi</li>
          <li>quando ti iscrivi alla newsletter</li>
          <li>quando utilizzi i nostri servizi digitali</li>
          <li>quando visiti i nostri canali social</li>
          <li>quando ci contatti</li>
          <li>quando partecipi alle nostre aste</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Dati personali che possiamo trattare</h2>
        <ul>
          <li>Nome e cognome</li>
          <li>Indirizzo postale</li>
          <li>Indirizzo di fatturazione</li>
          <li>Indirizzo e-mail</li>
          <li>Numero di telefono</li>
          <li>Paese</li>
          <li>Ragione sociale</li>
          <li>Partita IVA / Codice Fiscale</li>
          <li>Numero cliente</li>
          <li>Transazioni</li>
          <li>Acquisti</li>
          <li>Password e nome utente</li>
          <li>Copia del documento d'identità</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Finalità del trattamento</h2>
        <p>I dati vengono trattati per:</p>
        <ul>
          <li>Gestire pagamenti (base contrattuale)</li>
          <li>Creare e gestire account (base contrattuale)</li>
          <li>Monitorare lo storico pagamenti (obblighi di legge)</li>
          <li>Emettere fatture (base contrattuale)</li>
          <li>Fornire accesso alla piattaforma Equus Prime (base contrattuale)</li>
          <li>Gestire aste e offerte (base contrattuale)</li>
          <li>Inviare newsletter (consenso)</li>
          <li>Organizzare eventi (base contrattuale)</li>
          <li>Gestire i diritti previsti dal GDPR (obbligo legale)</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Cookie Policy</h2>
        <p>Equus Prime utilizza cookie e altre tecnologie di tracciamento per offrirti la migliore esperienza possibile dei nostri prodotti. I cookie ci aiutano a:</p>
        <ul>
          <li>Mantenere le tue preferenze di sessione</li>
          <li>Analizzare il traffico del sito</li>
          <li>Migliorare i nostri servizi</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Con chi condividiamo i tuoi dati?</h2>
        <p>Per gli ordini e le iscrizioni ai servizi di Equus Prime, i dati personali possono essere comunicati a terzi (persone o aziende esterne a Equus Prime) nella misura necessaria per:</p>
        <ul>
          <li>Elaborare pagamenti</li>
          <li>Emettere fatture</li>
          <li>Gestire richieste e ordini</li>
        </ul>
        <p>Abbiamo stipulato specifici accordi di trattamento dati con ogni fornitore con cui collaboriamo. I nostri fornitori sono autorizzati a trattare i dati solo secondo le disposizioni della presente policy e secondo le nostre istruzioni.</p>

        <h2 className="font-display text-2xl mt-8">Trasferimento dati fuori dall'UE</h2>
        <p>Alcuni dei nostri fornitori si trovano al di fuori dell'UE e del SEE (Spazio Economico Europeo). In caso di trasferimento, richiediamo che vi sia un supporto legale, ad esempio clausole contrattuali standard approvate dalla Commissione Europea.</p>

        <h2 className="font-display text-2xl mt-8">Per quanto tempo conserviamo i dati?</h2>
        <p>Conserviamo i tuoi dati personali per il tempo necessario a adempiere ai nostri obblighi, ovvero fornire il servizio o il prodotto, fatturare, gestire reclami, gestire richieste GDPR, ecc.</p>
        <p>Equus Prime conserva i tuoi dati personali fino a quando non richiedi la loro cancellazione, comunque per un massimo di tre anni dalla fine del rapporto con il cliente.</p>
        <p>Se hai fatto offerte, acquistato o venduto un oggetto, il rapporto con il cliente termina quando l'asta si conclude o al tuo ultimo accesso.</p>
        <p>Alcuni dati devono essere conservati più a lungo per adempiere agli obblighi di legge (es. legge sulla contabilità - 10 anni).</p>

        <h2 className="font-display text-2xl mt-8">I tuoi diritti</h2>
        <p>Hai diritto di:</p>
        <ul>
          <li><strong>Accesso</strong>: ottenere i dati personali che ci hai fornito</li>
          <li><strong>Rettifica</strong>: correggere dati inesatti</li>
          <li><strong>Cancellazione</strong>: richiedere la cancellazione dei tuoi dati</li>
          <li><strong>Portabilità</strong>: ricevere i tuoi dati in formato leggibile</li>
          <li><strong>Opposizione</strong>: opporti al trattamento basato su interesse legittimo</li>
          <li><strong>Revoca del consenso</strong>: ritirare il consenso in qualsiasi momento</li>
        </ul>
        <p>Contattaci via <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a> per esercitare i tuoi diritti. Potrebbe esserti chiesto di identificarti.</p>

        <h2 className="font-display text-2xl mt-8">Opposizione al marketing diretto</h2>
        <p>Se non desideri più ricevere informazioni commerciali e offerte da Equus Prime, puoi richiedere che cessiamo l'utilizzo dei tuoi dati personali per questi scopi. Provvederemo senza ritardo.</p>

        <h2 className="font-display text-2xl mt-8">Link esterni</h2>
        <p>Su equusprime.it possono essere presenti link ad altri siti web. La presente policy non si applica a tali siti. Ti consigliamo di consultare le loro politiche sulla privacy prima di fornire i tuoi dati personali.</p>

        <h2 className="font-display text-2xl mt-8">Sicurezza</h2>
        <p>Nessun sistema tecnologico è completamente protetto dalle intrusioni. Equus Prime adotta misure di sicurezza appropriate, in particolare misure tecniche e organizzative, per proteggere i tuoi dati personali da perdita accidentale, distruzione, uso improprio, danneggiamento e accesso non autorizzato o illegale.</p>

        <h2 className="font-display text-2xl mt-8">Reclami</h2>
        <p>Hai il diritto di presentare un reclamo relativo al nostro trattamento dei dati personali al:</p>
        <p>
          <strong>Garante per la Protezione dei Dati Personali</strong><br />
          Piazza Venezia, 11 - 00187 Roma<br />
          Telefono: (+39) 06.696771<br />
          E-mail: <a href="mailto:garante@gpdp.it" className="text-[#c9a227]">garante@gpdp.it</a><br />
          Sito: <a href="https://www.garanteprivacy.it" className="text-[#c9a227]" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>
        </p>

        <h2 className="font-display text-2xl mt-8">Modifiche alla Privacy Policy</h2>
        <p>La presente Privacy Policy verrà aggiornata periodicamente.</p>
        <p><strong>Ultimo aggiornamento: Marzo 2026</strong></p>

        <h2 className="font-display text-2xl mt-8">Contatti</h2>
        <p>Per domande sulla nostra Privacy Policy o sul trattamento dei dati personali, contattaci:</p>
        <p>
          <strong>Blinkers Srl</strong><br />
          E-mail: <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>
        </p>
      </div>
    </section>
  </div>
);


const CookiePage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Cookie Policy</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl prose prose-lg">
        <h2 className="font-display text-2xl">Cosa sono i Cookie?</h2>
        <p>I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. Servono a migliorare la tua esperienza di navigazione.</p>

        <h2 className="font-display text-2xl mt-8">Cookie che utilizziamo</h2>
        
        <h3 className="font-display text-xl mt-6">Cookie Tecnici (Necessari)</h3>
        <p>Questi cookie sono essenziali per il funzionamento del sito. Includono:</p>
        <ul>
          <li>Cookie di sessione per mantenere il login</li>
          <li>Cookie per ricordare le preferenze</li>
          <li>Cookie di sicurezza</li>
        </ul>

        <h3 className="font-display text-xl mt-6">Cookie Analitici</h3>
        <p>Ci aiutano a capire come i visitatori interagiscono con il sito, raccogliendo informazioni in forma anonima.</p>

        <h3 className="font-display text-xl mt-6">Cookie di Marketing</h3>
        <p>Utilizzati per mostrare annunci pertinenti e misurare l'efficacia delle campagne pubblicitarie.</p>

        <h2 className="font-display text-2xl mt-8">Come gestire i Cookie</h2>
        <p>Puoi gestire le preferenze sui cookie attraverso le impostazioni del tuo browser. Tieni presente che disabilitare alcuni cookie potrebbe influire sulla funzionalità del sito.</p>

        <h2 className="font-display text-2xl mt-8">Contatti</h2>
        <p>Per domande sulla nostra Cookie Policy, contattaci a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a></p>

        <p className="mt-8 text-[#64748b]">Ultimo aggiornamento: Marzo 2026</p>
      </div>
    </section>
  </div>
);


const CustomerServicePage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <p className="text-[#c9a227] text-lg mb-2">Hai domande?</p>
        <h1 className="font-display text-5xl text-white">Ti aiutiamo noi!</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom">
        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white border border-gray-200 p-8 text-center">
            <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-[#0a1628]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="font-display text-xl mb-2">Guida alle Offerte</h3>
            <p className="text-[#64748b] mb-4">Domande frequenti sulle offerte su Equus Prime</p>
            <a href="#faq" className="text-[#c9a227] font-medium hover:underline">Domande e risposte →</a>
          </div>
          
          <div className="bg-white border border-gray-200 p-8 text-center">
            <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-[#0a1628]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="font-display text-xl mb-2">E-mail</h3>
            <p className="text-[#64748b] mb-4">Contattaci via e-mail</p>
            <a href="mailto:info@equusprime.it" className="text-[#c9a227] font-medium hover:underline">info@equusprime.it</a>
          </div>
          
          <div className="bg-white border border-gray-200 p-8 text-center">
            <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-[#0a1628]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <h3 className="font-display text-xl mb-2">Telefono</h3>
            <p className="text-[#64748b] mb-4">Per questioni urgenti</p>
            <a href="tel:+390212345678" className="text-[#c9a227] font-medium hover:underline">+39 02 1234567</a>
          </div>
        </div>

        {/* FAQ Section */}
        <div id="faq" className="max-w-4xl mx-auto">
          <h2 className="font-display text-3xl mb-8 text-center">Domande Frequenti</h2>
          
          <div className="space-y-6">
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Come registro un account?</h3>
              <p className="text-[#64748b]">
                Per creare un account devi avere almeno 18 anni. Puoi registrarti con email e password oppure con Google. 
                Dopo la registrazione, invia una copia del tuo documento d'identità a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a> per la verifica dell'account.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Come iscrivo un cavallo all'asta?</h3>
              <p className="text-[#64748b]">
                Per vendere un cavallo su Equus Prime, contattaci via email a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>. 
                Ti guideremo attraverso il processo di iscrizione. Riceverai una conferma quando la tua iscrizione sarà approvata. 
                Non dimenticare di leggere i <a href="/termini-asta" className="text-[#c9a227]">termini dell'asta</a>!
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Come funzionano gli incrementi delle offerte?</h3>
              <p className="text-[#64748b]">
                L'offerta minima (apertura) è di <strong>€500</strong>. L'incremento minimo per ogni offerta è di <strong>€100</strong>. 
                Puoi offrire qualsiasi importo superiore all'offerta attuale + €100.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Quando termina l'asta?</h3>
              <p className="text-[#64748b]">
                Ogni cavallo ha un orario di chiusura dinamico. Se un'offerta arriva negli ultimi <strong>2 minuti</strong>, 
                l'asta viene automaticamente prolungata di altri 2 minuti. Questo sistema "anti-snipe" garantisce a tutti pari opportunità di rilancio.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Cosa succede quando vinco un'asta?</h3>
              <p className="text-[#64748b]">
                Riceverai una comunicazione da Equus Prime con i dettagli per il pagamento tramite bonifico bancario. 
                Ti assisteremo durante tutto il processo di acquisto.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Posso rimanere anonimo?</h3>
              <p className="text-[#64748b]">
                Durante l'asta sei sempre anonimo. I partecipanti sono identificati come "Offerente 1", "Offerente 2", ecc. 
                Solo dopo la conclusione dell'asta vengono comunicati i dati del vincitore al venditore.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Quanto costa vendere un cavallo su Equus Prime?</h3>
              <p className="text-[#64748b]">
                L'inserimento dei cavalli all'asta, comprese le monte, è <strong>sempre gratuito</strong>. 
                Equus Prime applica una commissione del <strong>3,5%</strong> sul prezzo di vendita (a carico del venditore) 
                e una commissione del <strong>3,5%</strong> (a carico dell'acquirente). In caso di ricompra la commissione è del <strong>2%</strong>. Tutti gli importi sono IVA esclusa.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-6">
              <h3 className="font-display text-lg mb-3 text-[#c9a227]">Voglio saperne di più sulle aste partner</h3>
              <p className="text-[#64748b]">
                Equus Prime offre la propria piattaforma ad allevatori, società d'asta o proprietari di cavalli con possibilità di personalizzazione. 
                Contattaci a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a> per saperne di più.
              </p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <p className="text-lg mb-4">Hai altre domande?</p>
            <a href="mailto:info@equusprime.it" className="btn-primary inline-block">
              Contattaci
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);


const AboutPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Informazioni su Equus Prime</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl">
        <div className="prose prose-lg">
          <p className="text-xl leading-relaxed mb-8">
            Equus Prime è una piattaforma flessibile con tecnologia moderna, progettata per le aste del futuro. 
            Il nostro obiettivo è creare un mercato attraente nel mondo equestre, dove qualità e continuità 
            sono le parole chiave del nostro lavoro.
          </p>

          <div className="bg-[#f8f9fa] p-8 mb-8">
            <h2 className="font-display text-2xl mb-4">La Nostra Mission</h2>
            <p>
              Le ambizioni di Equus Prime sono alte: vogliamo offrire i cavalli più interessanti e il miglior servizio. 
              Equus Prime ha un focus chiaro sul cliente, sia acquirente che venditore. Abbiamo l'esperienza, 
              la conoscenza e la rete di contatti necessari per una transazione di successo.
            </p>
          </div>

          <h2 className="font-display text-2xl mt-8 mb-4">Cosa Offriamo</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="border border-gray-200 p-6">
              <h3 className="font-display text-xl mb-3 text-[#c9a227]">Tecnologia Avanzata</h3>
              <p className="text-[#64748b]">
                Sistema d'asta moderno con countdown in tempo reale e protezione anti-snipe per garantire 
                aste eque e trasparenti.
              </p>
            </div>
            <div className="border border-gray-200 p-6">
              <h3 className="font-display text-xl mb-3 text-[#c9a227]">Esperienza</h3>
              <p className="text-[#64748b]">
                Dietro Equus Prime ci sono persone con grande esperienza nel mondo equestre e nelle aste.
              </p>
            </div>
            <div className="border border-gray-200 p-6">
              <h3 className="font-display text-xl mb-3 text-[#c9a227]">Aste Partner</h3>
              <p className="text-[#64748b]">
                Offriamo aste partner con la possibilità per il cliente di costruire la propria asta 
                personalizzata con la tecnologia Equus Prime.
              </p>
            </div>
            <div className="border border-gray-200 p-6">
              <h3 className="font-display text-xl mb-3 text-[#c9a227]">Focus sul Cliente</h3>
              <p className="text-[#64748b]">
                Ogni decisione che prendiamo è guidata dal desiderio di offrire la migliore esperienza 
                possibile ai nostri utenti.
              </p>
            </div>
          </div>

          <div className="bg-[#0a1628] text-white p-8 mb-8">
            <h2 className="font-display text-2xl mb-4 text-[#c9a227]">Chi Siamo</h2>
            <p className="mb-4">
              Equus Prime è di proprietà di <strong>Blinkers Srl</strong>, che ne cura anche la gestione. Con sede a Marigliano (NA), 
              siamo dedicati a portare innovazione nel mercato delle aste equestri in Italia.
            </p>
            <ul className="space-y-2 text-white/80">
              <li><strong>Ragione Sociale:</strong> Blinkers Srl</li>
              <li><strong>P.IVA:</strong> 11115801216</li>
              <li><strong>Sede:</strong> Via Isonzo 36, 80034 Marigliano (NA)</li>
              <li><strong>Email:</strong> <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a></li>
            </ul>
          </div>

          <h2 className="font-display text-2xl mt-8 mb-4">Contattaci</h2>
          <p className="mb-6">
            Hai domande o commenti su Equus Prime? Non esitare a contattarci!
          </p>
          <a href="mailto:info@equusprime.it" className="btn-primary inline-block">
            Scrivici
          </a>
        </div>
      </div>
    </section>
  </div>
);


const PartnerAuctionsPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Aste per Partner</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl">
        <div className="prose prose-lg">
          <p className="text-xl leading-relaxed mb-8">
            Equus Prime offre la propria piattaforma ad allevatori, società d'asta o proprietari di cavalli. 
            È possibile personalizzare l'asta secondo le vostre esigenze.
          </p>

          <div className="bg-[#f8f9fa] p-8 mb-8">
            <h2 className="font-display text-2xl mb-4">Cosa offriamo</h2>
            <ul className="space-y-3">
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Piattaforma d'asta personalizzata con il vostro brand</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Gestione completa delle aste online</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Sistema anti-snipe e countdown in tempo reale</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Supporto tecnico dedicato</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Visibilità sulla nostra rete di acquirenti qualificati</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#c9a227]">✓</span>
                <span>Condizioni commerciali personalizzate</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#0a1628] text-white p-8 mb-8">
            <h2 className="font-display text-2xl mb-4 text-[#c9a227]">Ideale per</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-[#0a1628] text-2xl">🐴</span>
                </div>
                <h3 className="font-bold mb-2">Allevatori</h3>
                <p className="text-white/70 text-sm">Vendi i tuoi puledri e cavalli direttamente agli acquirenti</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-[#0a1628] text-2xl">🏢</span>
                </div>
                <h3 className="font-bold mb-2">Società d'Asta</h3>
                <p className="text-white/70 text-sm">Utilizza la nostra tecnologia per le tue aste</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#c9a227] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-[#0a1628] text-2xl">👥</span>
                </div>
                <h3 className="font-bold mb-2">Proprietari</h3>
                <p className="text-white/70 text-sm">Organizza aste private per il tuo gruppo</p>
              </div>
            </div>
          </div>

          <h2 className="font-display text-2xl mt-8 mb-4">Contattaci</h2>
          <p className="mb-6">
            Contattaci per saperne di più su come possiamo creare qualcosa su misura per te.
          </p>
          <a href="mailto:info@equusprime.it" className="btn-primary inline-block">
            Richiedi Informazioni
          </a>
          <p className="mt-4 text-[#64748b]">
            Oppure scrivi a: <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>
          </p>
        </div>
      </div>
    </section>
  </div>
);


const AuctionTermsPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Termini dell'Asta</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl prose prose-lg">
        
        <h2 className="font-display text-2xl">1. Disposizioni Generali</h2>
        <p>Equus Prime è di proprietà di Blinkers Srl, che ne cura anche la gestione. I presenti termini si applicano come condizioni standard per l'utilizzo della piattaforma elettronica su internet che Blinkers Srl ("Equus Prime"), P.IVA 11115801216, mette a disposizione sul sito www.equusprime.it ("Servizio").</p>
        <p>I termini regolano il rapporto contrattuale tra acquirenti e venditori che partecipano alle aste di cavalli organizzate da Equus Prime. Questi termini si applicano anche ai clienti che registrano un account sul sito Equus Prime.</p>
        <p>Equus Prime è esclusivamente un intermediario di una piattaforma elettronica per l'asta di cavalli via internet e non è da considerarsi un banditore d'asta in senso tradizionale.</p>

        <h2 className="font-display text-2xl mt-8">2. Rapporti tra le Parti</h2>
        <p>Equus Prime è esclusivamente un intermediario di una piattaforma elettronica per l'asta di cavalli, dove Acquirenti e Venditori possono concludere un contratto di compravendita. Il rapporto contrattuale relativo alla compravendita sussiste quindi esclusivamente tra Acquirente e Venditore.</p>
        <p>Equus Prime non è proprietario di ciò che viene offerto in vendita sulla piattaforma elettronica.</p>
        <p>Equus Prime non è responsabile delle informazioni fornite dall'Acquirente o dal Venditore relative a: dati personali, capacità di pagamento, informazioni sulle condizioni dei cavalli, ecc.</p>

        <h2 className="font-display text-2xl mt-8">3. Registrazione Account</h2>
        <p>La registrazione di un account sul sito Equus Prime è necessaria per partecipare alle offerte e per proporre cavalli in vendita.</p>
        <p>Il Cliente deve registrare informazioni corrette e complete e si impegna a mantenerle aggiornate.</p>
        <p>Per partecipare alle aste, dopo la registrazione è necessario inviare copia di un documento d'identità valido a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a> per la verifica dell'account.</p>
        <p>La registrazione non è consentita se: i) la persona ha meno di 18 anni, ii) la persona non ha capacità giuridica, iii) la persona è stata sospesa dal proprio account temporaneamente o permanentemente, iv) Equus Prime ha altre motivazioni per rifiutare la registrazione.</p>

        <h2 className="font-display text-2xl mt-8">4. Servizio e Utilizzo</h2>
        <p>Equus Prime si impegna a mantenere una buona sicurezza e accessibilità al Servizio. Tuttavia, Equus Prime non garantisce che il Servizio sia disponibile senza interruzioni.</p>
        <p>Equus Prime non è responsabile per eventuali danni derivanti dall'impossibilità del Cliente di utilizzare il Servizio, ad esempio per fare un'offerta.</p>
        <p>Equus Prime ha il diritto di sospendere i Clienti e i loro account dall'utilizzo temporaneo o permanente del Servizio, inclusi i Clienti che non rispettano i Termini o che abusano in altro modo del Servizio.</p>

        <h2 className="font-display text-2xl mt-8">5. Iscrizione Cavalli all'Asta e Tariffe</h2>
        <p>L'asta è aperta per cavalli registrati e altri cavalli approvati da Equus Prime.</p>
        <p>L'inserimento dei cavalli all'asta, comprese le monte, è <strong>sempre gratuito</strong>.</p>
        <p>Le tariffe sono le seguenti:</p>
        <ul>
          <li><strong>Commissione di vendita</strong>: 3,5% del prezzo di vendita (a carico del Venditore)</li>
          <li><strong>Commissione di acquisto</strong>: 3,5% del prezzo di vendita (a carico dell'Acquirente)</li>
          <li><strong>Commissione di ricompra</strong>: 2% (in caso di ricompra del cavallo)</li>
        </ul>
        <p>L'IVA si applica a tutti gli importi secondo la normativa vigente.</p>

        <h2 className="font-display text-2xl mt-8">6. Offerte e Prezzi</h2>
        <p>La vendita avviene sul sito Equus Prime nel giorno dell'asta agli orari prestabiliti.</p>
        <p><strong>Equus Prime applica il tempo dinamico (anti-snipe)</strong>: il tempo per le offerte viene prolungato di due minuti dall'ultima offerta sui cavalli che hanno avuto offerte entro due minuti dalla fine. Dopo questo periodo di due minuti, il tempo viene prolungato di altri due minuti se vengono fatte ulteriori offerte entro questo periodo, e così via.</p>
        <p><strong>Offerta minima</strong>: €500 (se non diversamente indicato)</p>
        <p><strong>Incremento minimo</strong>: €100 per offerta</p>
        <p>Tutte le offerte sono vincolanti per il Cliente e non possono essere modificate o ritirate.</p>
        <p>L'acquisto vincolante si perfeziona tra chi ha fatto l'offerta più alta entro il tempo di offerta e il Venditore. Il contratto tra Acquirente e Venditore si considera concluso non appena l'asta è terminata.</p>
        <p>Se due o più Clienti hanno fatto offerte di pari importo, avrà la precedenza quella registrata per prima nel Servizio.</p>

        <h2 className="font-display text-2xl mt-8">7. Condizioni dei Cavalli</h2>
        <p>I cavalli sono venduti "così come sono" (as is). Un difetto del cavallo può essere fatto valere solo secondo le modalità e nei tempi indicati nella sezione Reclami.</p>
        <p>Il Venditore deve fornire a Equus Prime un certificato veterinario indipendente al massimo 1 giorno prima del giorno dell'asta. Tale certificato veterinario non deve essere anteriore a 7 giorni dalla data dell'asta.</p>
        <p>Se si tratta di una cavalla gravida, la gravidanza deve essere confermata con un certificato da inviare a Equus Prime almeno tre giorni prima del giorno dell'asta.</p>

        <h2 className="font-display text-2xl mt-8">8. Rapporto tra Equus Prime e il Venditore</h2>
        <p>Il Venditore è responsabile delle informazioni fornite sul cavallo e garantisce di avere il diritto legale di effettuare la vendita.</p>
        <p>Il Venditore è l'unico responsabile per eventuali difetti o vizi del cavallo.</p>
        <p>Equus Prime non è responsabile della verifica dell'identità e della capacità di pagamento degli offerenti, cosa che il Venditore accetta.</p>

        <h2 className="font-display text-2xl mt-8">9. Rapporto tra Acquirente e Venditore, Reclami e Diritto di Recesso</h2>
        <p>Il Venditore è responsabile delle informazioni fornite sul cavallo e del trasferimento di proprietà dopo il pagamento dell'Acquirente.</p>
        <p>L'Acquirente deve ispezionare il cavallo dopo la consegna. L'Acquirente ha il diritto di far valere un difetto scoperto durante una normale ispezione se:</p>
        <ul>
          <li>il difetto comporta che il cavallo non corrisponde alle informazioni fornite prima dell'acquisto che possono aver influenzato l'acquisto</li>
          <li>il Venditore prima dell'acquisto ha omesso di informare l'Acquirente di una circostanza essenziale relativa alle caratteristiche o all'uso del cavallo</li>
          <li>il cavallo è in condizioni sostanzialmente peggiori di quanto l'Acquirente potesse ragionevolmente aspettarsi in considerazione del prezzo e delle altre circostanze</li>
        </ul>
        <p>L'Acquirente deve entro <strong>14 giorni</strong> dalla consegna far eseguire una visita veterinaria.</p>
        <p>L'Acquirente non può far valere che il cavallo è difettoso se non reclama al Venditore entro <strong>14 giorni</strong> da quando ha notato o avrebbe dovuto notare il difetto.</p>
        <p>Se l'Acquirente è un consumatore e il Venditore è un professionista, l'Acquirente ha anche il diritto di recedere dal contratto (Diritto di Recesso) inviando al Venditore una comunicazione chiara entro <strong>14 giorni</strong> dal giorno in cui ha preso possesso del cavallo.</p>

        <h2 className="font-display text-2xl mt-8">10. Condizioni di Pagamento</h2>
        <p>Dopo la conclusione dell'asta, Equus Prime comunicherà all'Acquirente i dati per il pagamento.</p>
        <p>Il pagamento avviene tramite <strong>bonifico bancario</strong>.</p>
        <p>L'Acquirente deve effettuare il pagamento completo entro <strong>10 giorni</strong> dalla conclusione dell'asta, salvo diverso accordo tra Acquirente e Venditore.</p>
        <p>Il pagamento completo include, oltre al prezzo di acquisto del cavallo, la commissione a Equus Prime del 3,5% del prezzo di vendita, nonché altre spese ed eventuali imposte relative all'acquisto.</p>
        <p>Se il pagamento completo non viene effettuato entro il termine indicato o l'Acquirente rifiuta in altro modo di partecipare all'acquisto, il Venditore ha il diritto di recedere o di completare l'acquisto e richiedere il pagamento.</p>

        <h2 className="font-display text-2xl mt-8">11. Consegna e Passaggio del Rischio</h2>
        <p>La consegna del cavallo deve avvenire entro <strong>10 giorni</strong> dalla data della fattura. Ciò significa che l'Acquirente deve ritirare il cavallo presso il Venditore entro tale termine.</p>
        <p>Il Venditore non ha l'obbligo di consegnare il cavallo prima di aver ricevuto il pagamento completo.</p>
        <p>La proprietà del cavallo passa all'Acquirente quando il pagamento completo è stato effettuato al Venditore.</p>
        <p>Il Venditore sopporta il rischio per il cavallo fino alla consegna. La consegna avviene quando l'Acquirente ha preso in consegna il cavallo.</p>
        <p>L'assicurazione deve essere stipulata dall'Acquirente in modo che sia valida dal momento della consegna del cavallo.</p>

        <h2 className="font-display text-2xl mt-8">12. Riserva di Proprietà</h2>
        <p>Il Venditore si riserva il diritto di trattenere o riprendere il cavallo venduto e l'eventuale prole fino a quando non avrà ricevuto il pagamento completo.</p>

        <h2 className="font-display text-2xl mt-8">13. Forza Maggiore</h2>
        <p>L'asta può, su decisione unilaterale di Equus Prime, essere spostata a causa di eventi di forza maggiore. Per evento di forza maggiore si intende una circostanza imprevedibile al di fuori del controllo di Equus Prime, ad esempio incendio, alluvione, guerra, eventi bellici, sommosse, scioperi, malattie contagiose, calamità naturali, regolamenti o altri provvedimenti delle autorità in Italia o all'estero.</p>

        <h2 className="font-display text-2xl mt-8">14. Trattamento dei Dati Personali</h2>
        <p>Equus Prime è soggetta alle disposizioni del Regolamento (UE) 2016/679 (GDPR) e della normativa italiana in materia di protezione dei dati personali.</p>
        <p>Blinkers Srl, P.IVA 11115801216, sede: Via Isonzo 36, 80034 Marigliano (NA), <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>, è il Titolare del trattamento dei dati raccolti e trattati sul Cliente per poter fornire il Servizio.</p>
        <p>Per maggiori informazioni, consultare la nostra <a href="/privacy" className="text-[#c9a227]">Politica sulla Privacy</a>.</p>

        <h2 className="font-display text-2xl mt-8">15. Legge Applicabile e Controversie</h2>
        <p>La legge italiana si applica ai rapporti tra Equus Prime e il Venditore e tra il Venditore e l'Acquirente.</p>
        <p>Eventuali controversie saranno risolte dal tribunale italiano competente, con il Foro di Nola come prima istanza.</p>

        <h2 className="font-display text-2xl mt-8">16. Disposizioni Varie</h2>
        <p>Il Cliente ha il diritto di chiudere il proprio account su Equus Prime su richiesta inviando una email a <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>.</p>
        <p>Prima della chiusura dell'account, tutte le vendite, offerte e acquisti in corso devono essere conclusi.</p>
        <p>Equus Prime si riserva il diritto di modificare i presenti Termini in qualsiasi momento.</p>

        <h2 className="font-display text-2xl mt-8">Contatti</h2>
        <p>
          <strong>Blinkers Srl</strong><br />
          P.IVA: 11115801216<br />
          Via Isonzo 36<br />
          80034 Marigliano (NA)<br />
          E-mail: <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>
        </p>

        <p className="mt-8 text-[#64748b]"><em>Versione 2026:1 - In vigore dal 1 Marzo 2026</em></p>
      </div>
    </section>
  </div>
);


const TermsPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white">Termini e Condizioni</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl prose prose-lg">
        <h2 className="font-display text-2xl">1. Premessa</h2>
        <p>I presenti Termini e Condizioni regolano l'utilizzo della piattaforma Equus Prime. Equus Prime è di proprietà di Blinkers Srl, che ne cura anche la gestione. Blinkers Srl ha P.IVA 11115801216 e sede in Via Isonzo 36, 80034 Marigliano (NA).</p>

        <h2 className="font-display text-2xl mt-8">2. Registrazione e Account</h2>
        <p>Per partecipare alle aste è necessario:</p>
        <ul>
          <li>Creare un account sulla piattaforma</li>
          <li>Inviare copia di un documento d'identità valido a info@equusprime.it</li>
          <li>Attendere la verifica e l'attivazione dell'account da parte del nostro team</li>
        </ul>
        <p>Gli account non verificati possono solo visualizzare le aste ma non partecipare.</p>

        <h2 className="font-display text-2xl mt-8">3. Sistema d'Asta</h2>
        <p>Le aste su Equus Prime seguono le seguenti regole:</p>
        <ul>
          <li>Offerta minima: €500</li>
          <li>Incremento minimo: €100</li>
          <li>Tempo dinamico: se un'offerta viene effettuata negli ultimi 2 minuti, l'asta si prolunga automaticamente di 2 minuti</li>
          <li>Tutte le offerte sono vincolanti e non possono essere ritirate</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">4. Pagamenti</h2>
        <p>Al termine dell'asta:</p>
        <ul>
          <li>L'acquirente vincitore riceverà una fattura via email con le coordinate bancarie per il pagamento</li>
          <li>Il pagamento deve essere effettuato tramite bonifico bancario entro 10 giorni</li>
          <li>Il cavallo può essere ritirato solo dopo la conferma del pagamento</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">5. Condizioni dei Cavalli</h2>
        <p>I cavalli sono venduti "così come sono". Il venditore è tenuto a fornire:</p>
        <ul>
          <li>Certificato veterinario recente (massimo 7 giorni)</li>
          <li>Documentazione completa del cavallo</li>
          <li>Descrizione accurata delle condizioni e caratteristiche</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">6. Reclami</h2>
        <p>Eventuali reclami devono essere presentati entro 14 giorni dalla consegna del cavallo. Il reclamo deve essere inviato via email a info@equusprime.it con documentazione a supporto.</p>

        <h2 className="font-display text-2xl mt-8">7. Privacy</h2>
        <p>I dati personali sono trattati in conformità al GDPR (Regolamento UE 2016/679). Per maggiori informazioni, consultare la nostra Privacy Policy.</p>

        <h2 className="font-display text-2xl mt-8">8. Legge Applicabile</h2>
        <p>I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Nola.</p>

        <p className="mt-8 text-[#64748b]">Ultimo aggiornamento: Gennaio 2026</p>
      </div>
    </section>
  </div>
);


const ContactPage = () => (
  <div>
    <section className="bg-[#0a1628] py-20">
      <div className="container-custom">
        <h1 className="font-display text-5xl text-white mb-4">Contatti</h1>
        <p className="text-white/70 text-xl">Siamo qui per aiutarti</p>
      </div>
    </section>

    <section className="section">
      <div className="container-custom max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="font-display text-3xl mb-6">Informazioni</h2>
            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-[#c9a227] mb-1">Azienda</h3>
                <p>Blinkers Srl</p>
                <p className="text-[#64748b]">P.IVA: 11115801216</p>
              </div>
              <div>
                <h3 className="font-bold text-[#c9a227] mb-1">Sede</h3>
                <p>Via Isonzo 36</p>
                <p>80034 Marigliano (NA)</p>
              </div>
              <div>
                <h3 className="font-bold text-[#c9a227] mb-1">Email</h3>
                <a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a>
              </div>
            </div>
          </div>
          <div>
            <h2 className="font-display text-3xl mb-6">Scrivici</h2>
            <p className="text-[#64748b] mb-6">
              Per qualsiasi domanda, informazione sulle aste o per vendere il tuo cavallo, contattaci via email.
            </p>
            <a href="mailto:info@equusprime.it" className="btn-primary inline-block">
              Invia Email
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);


export { HowToSellPage, PrivacyPage, CookiePage, CustomerServicePage, AboutPage, PartnerAuctionsPage, AuctionTermsPage, TermsPage, ContactPage };
